import React from 'react';

import { Box } from '@mui/material';

import { globalTheme } from '../../../../../../shared/theme/theme';

export const StatsFallbackComponent = () => {
  return (
    <Box
      sx={{
        textAlign: 'center',
        padding: '20px',
        color: globalTheme.palette.appGrey.darkGray,
      }}
    >
      No ratings available to display
    </Box>
  );
};
